// htmlToPdf.js
// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'
import $ from 'jquery'
export default {
    // install(Vue, options) {
        downloadPDF (file_id, file_title) {
            html2Canvas(document.querySelector('#' + file_id), {
                allowTaint: false,
                taintTest: false,
                logging: false,
                useCORS: true,
                dpi: window.devicePixelRatio * 4, // 将分辨率提高到特定的DPI 提高四倍
                scale: 4 // 按比例增加分辨率
              }).then(canvas => {
                // eslint-disable-next-line new-cap
                //var pdf = new jsPDF('l', 'mm', 'a3') // A3纸，横向
                //var pdf = new jsPDF('p', 'mm', 'a4') // A4纸，纵向
                var pdf = new jsPDF('l', 'mm', 'a4') // A4纸，纵向
                var ctx = canvas.getContext('2d')
                var a4w = 190; var a4h = 277 // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
                //var a4w = 259; var a4h = 400 // A3大小，279mm x 420mm，四边各保留10mm的边距，显示区域259x400
                var imgHeight = Math.floor(a4h * canvas.width / a4w) // 按A4显示比例换算一页图像的像素高度[这个计算方式应该是纵向]
               //  var imgHeight = Math.floor(a4w * canvas.width / a4h) // 按A4显示比例换算一页图像的像素高度[这个是横向打印的计算方法]
                var renderedHeight = 0
          
                while (renderedHeight < canvas.height) {
                  var page = document.createElement('canvas')
                  page.width = canvas.width
                  page.height = Math.min(imgHeight, canvas.height - renderedHeight)// 可能内容不足一页
          
                //   console.log(canvas.width, Math.min(imgHeight, canvas.height - renderedHeight))
                //   console.log(a4w, Math.min(a4h, a4w * page.height / page.width))
          
                  // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
                  page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0)
                  pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距 [a4使用]
                 //  pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w * 1.414, Math.min(a4h, a4w * page.height / page.width) * 1.414) // 添加图像到页面，保留10mm边距[a3使用1.414换算比例]
          
                  renderedHeight += imgHeight
                  console.log('imgHeight', imgHeight)
                  console.log('renderedHeight', renderedHeight)
                  console.log('canvas.height', canvas.height)
                  if (renderedHeight < canvas.height) {
                    pdf.addPage()// 如果后面还有内容，添加一个空页
                  }
                   
                }
                // 保存文件
                pdf.save(file_title + '.pdf')
              })
            // // var title = this.htmlTitle  //DPF标题
            // const title = file_title
            // const Dom_height = $('#' + file_id).height() //获取要截取的dom元素内容高度
            // const outer_height = $('#' + file_id).outerHeight() //获取dom元素的外部高度
            // const window_height = window.screen.availHeight //窗口高度
            // console.log(Dom_height,outer_height,window_height)
            // html2Canvas(document.querySelector('#' + file_id), {
            //     allowTaint: true,
            //     taintTest: false,
            //     useCORS: true,
            //     // height: window.screen.availHeight,
            //     height: Dom_height < window_height ? window_height : outer_height, //canvas画布的具体高度
            //     /*以上这个高度非常重要，如果dom内容高度在窗口高度内的话，那就用窗口高度，
            //     确保把当前页的内容都截取，如果超过一页，那就用外部高度*/
            //     // windowHeight: document.getElementById('#' + file_id).scrollHeight,
            //     y: window.pageYOffset - 30, //页面在垂直方向的滚动距离
            //     // width:1200,
            //     // height:5000,
            //     dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
            //     scale: 4 //按比例增加分辨率 
            // }).then(function (canvas) {
            //     let contentWidth = canvas.width
            //     let contentHeight = canvas.height
            //     let pageHeight = contentWidth / 592.28 * 841.89
            //     let leftHeight = contentHeight
            //     let position = 0        
            //     let imgWidth = 595.28
            //     let imgHeight = 592.28 / contentWidth * contentHeight
            //     let pageData = canvas.toDataURL('image/jpeg', 1.0)
            //     let PDF = new JsPDF('', 'pt', 'a4')
            //     if (leftHeight < pageHeight) {
            //         PDF.addImage(pageData, 'JPEG', 10, 10,  imgWidth, imgHeight)
            //     } else {
            //         while (leftHeight > 0) {
            //             PDF.addImage(pageData, 'JPEG', 10, position, imgWidth, imgHeight)
            //             leftHeight -= pageHeight
            //             position -= 841.89
            //             if (leftHeight > 0) {
            //                 PDF.addPage()
            //             }
            //         }
            //     }
            //     PDF.save(title + '.pdf')
            // })
        }
    // }
}



// WEBPACK FOOTER //
// ./src/assets/js/utils/htmlToPdf.js